import React from 'react';

export const Container = props => {
    return (
        <div className={ `application-container` }>
            { props.children }
        </div>
    );
}
 
export default Container;